(function () {
  'use strict';

  angular
    .module('doubleSectorPriorToDayTurnaround')
    .service('doubleSectorPriorToDayTurnaroundService', doubleSectorPriorToDayTurnaroundService);

  function doubleSectorPriorToDayTurnaroundService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchDoubleSectorPriorToDayTurnaround = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchDoubleSectorPriorToDayTurnaround(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function adaptSearchRequset(param) {
      console.log(param);
      const airportCodeList = [];
      if (param.destinations != null){
        param.destinations.forEach(function(airport){
          airportCodeList.push(airport.airPortCode);
        })
      }
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        crewType:(param.crewType !=null ) ? param.crewType.crewTypeCode:null,
        autoOrManual: (param.autoOrManual != null) ? param.autoOrManual.autoOrManualCode:null,
        destinationList: (param.destinations != null) ? airportCodeList:null,
      };

      return actualSearchParam;
    }

  }
}());
